import React from 'react';

import Button from 'buttons/button';

import styles from './dialog-example.less';
import externalStyles from '../example.less';

module.exports = React.createClass({
  getInitialState() {
    return {
      isDialogOpen: false,
      activeDialogCard: []
    }
  },
  propTypes: {
    onSave: React.PropTypes.func
  },
  handleButtonClick() {
    this.setState({ isDialogOpen: true });
  },
  handleCloseDialog() {
    this.closeDialog();
    this.setState({ activeDialogCard: [] });
  },
  handleSave() {
    this.props.onSave(this.state.activeDialogCard);
    this.closeDialog();
  },
  closeDialog() {
    this.setState({ isDialogOpen: false });
  },
  dialogActions() {
    return [
      <Button tabIndex={10001} type="filled-success" onClick={this.handleSave}>Save and Close</Button>,
      <Button tabIndex={10002} type="link" onClick={this.handleCloseDialog}>Cancel</Button>
    ]
  },
  handleDialogCardChange(value) {
    this.setState({activeDialogCard: value});
  },
  getStyles() {
    return Object.assign({}, styles, externalStyles);
  },
  render: require('./dialog-example.rt')
});



/** WEBPACK FOOTER **
 ** ./src/lists/example/dialog-example/index.js
 **/